import { PurchaseOrderStatus } from '@rematter/frontend-lib-api-client';

import { OrderRecordForLink } from '../types/brokeredOrder';

import { orderDetailFragment } from './fragmentOrderDetails';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

const LINK_ORDERS_PAGE_SIZE = 50;

export const purchaseOrdersForLinkQueryAtom = createQueryAtomFactory(
  'brokerage.purchaseOrdersForLink',
  (params: { searchTerm?: string; accountIds?: string[] }) => ({
    purchaseOrders: {
      __args: {
        filter: {
          searchTerm: params.searchTerm || undefined,
          accountIds: params.accountIds,
        },
        pagination: {
          limit: LINK_ORDERS_PAGE_SIZE,
          offset: 0,
        },
      },
      entries: {
        ...orderDetailFragment,
        lineItems: {
          id: true,
        },
        startDate: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { orders: OrderRecordForLink[]; total: number } => ({
      orders: data.purchaseOrders.entries.map(
        (order): OrderRecordForLink => ({
          id: order.id,
          documentNumber: order.documentNumber,
          status: order.status as PurchaseOrderStatus,
          accountName: order.account?.name ?? 'Unknown',
          address: order.account?.addresses?.map((a) => ({
            id: a.id,
            ...a.address,
          })),
          startDate: order.startDate,
          total: null,
          lineItems: order.lineItems.map((li) => ({
            id: li.id,
          })),
        }),
      ),
      total: data.purchaseOrders.page.total ?? 0,
    }),
  },
);
